<div
  class="barcode-component w-100 d-flex flex-column align-item-center d-lg-none"
  [ngClass]="isFreePopulation ? 'bg-allstar' : 'bg-primary'"
  *ngIf="memberCard$ | async as memberCard"
>
  <ng-container *ngIf="barcode$ | async as barcode">
    <div
      *ngIf="isHomePage && memberDetails$ | async as memberDetails"
      class="name-container d-flex flex-row align-items-center justify-content-between"
    >
      <div class="d-flex name-details-container d-flex flex-column">
        <div class="mb-0 text-uppercase text-white member-name">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</div>

        <ng-container *ngIf="memberCard$ | async as memberCard">
          <div class="text-white font-size-12">
            {{ memberCard?.ProductCodeDisplayName || membercard?.ProductCode }} - {{ memberCard.ExternalRefNumber }}
          </div>
        </ng-container>
      </div>

      <ng-container *inPopulation="[populations.Default, populations.Partner]">
        <img
          *ngIf="tierName == tierLevels.Mvp"
          alt=""
          src="assets/images/tier-logo/tier_logo_mvp.svg"
          draggable="false"
          height="24"
        />
        <img
          *ngIf="tierName == tierLevels.AllStar"
          alt=""
          src="assets/images/tier-logo/tier_logo_all_star.svg"
          draggable="false"
          height="24"
        />
        <img
          *ngIf="tierName == tierLevels.Legend"
          alt=""
          src="assets/images/tier-logo/tier_logo_legends.svg"
          draggable="false"
          height="24"
        />
        <img
          *ngIf="tierName == tierLevels.Pro"
          alt=""
          src="assets/images/tier-logo/tier_logo_pro.svg"
          draggable="false"
          height="24"
        />
      </ng-container>
      <ng-container *inPopulation="[populations.Free]">
        <img
          *ngIf="tierName == tierLevels.Mvp"
          alt=""
          src="assets/images/tier-logo/tier_logo_mvp_white.png"
          draggable="false"
          height="24"
        />
        <img
          *ngIf="tierName == tierLevels.AllStar"
          alt=""
          src="assets/images/tier-logo/tier_logo_all_star_white.png"
          draggable="false"
          height="24"
        />
        <img
          *ngIf="tierName == tierLevels.Legend"
          alt=""
          src="assets/images/tier-logo/tier_logo_legends_white.png"
          draggable="false"
          height="24"
        />
        <img
          *ngIf="tierName == tierLevels.Pro"
          alt=""
          src="assets/images/tier-logo/tier_logo_pro_white.png"
          draggable="false"
          height="24"
        />
      </ng-container>
    </div>

    <!-- QR Container -->
    <ng-container *notInPopulation="[populations.Suite, populations.Pts]">
      <div class="qr-container w-100 m-0">
        <div
          class="show-qr-btn w-100"
          (click)="onClickShowQr()"
          [ngClass]="{ 'hide-qr-btn': showQr, 'bg-glass': !isFreePopulation, 'bg-glass-dark': isFreePopulation }"
        >
          <span class="material-symbols-outlined text-white"> qr_code_scanner </span>
          <label class="font-size-14 text-capitalize fw-normal text-white">{{ 'barcode.member.show.qr' | translate }}</label>
        </div>

        <div
          class="qr text-center rounded position-relative"
          [ngClass]="{
            'show-qr': showQr,
            'bg-glass-dark': isFreePopulation,
            'bg-glass': !isFreePopulation,
            'show-free-qr': isFreePopulation && showQr,
          }"
        >
          <!-- close qr -->
          <span class="material-symbols-outlined collapse-icon text-white" (click)="onClickShowQr()"> close_fullscreen </span>

          <div class="qr-box d-flex flex-column align-items-center justify-content-center">
            <qrcode [qrdata]="barcode.Barcode" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
            <label for="" class="font-size-12 fw-normal text-center text-capitalize text-white">{{
              'barcode.member.scan.qr' | translate
            }}</label>
          </div>

          <ng-container *notInPopulation="[populations.Free]">
            <div class="d-flex gap-2 flex-column">
              <div class="d-flex flex-row align-items-center justify-content-between w-100">
                <!--Discount-->
                <div class="font-size-14 mb-0">{{ 'member.card.discountlevel' | translate }}</div>
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'">
                  <label class="font-size-14 fw-bold mb-0">{{ memberCard.DiscountLevel | getNumber }}%</label>
                </ng-container>
                <!--Discount Day F&B-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
                  <label class="font-size-14 fw-bold mb-0">{{ 'member.card.discount.day.fandb.value' | translate }}%</label>
                </ng-container>
              </div>

              <div class="d-flex flex-row align-items-center justify-content-between w-100">
                <div class="font-size-14 mb-0">{{ 'member.card.discount' | translate }}</div>
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'">
                  <label class="font-size-14 fw-bold mb-0">{{ memberCard.RetailDiscountLevel | getNumber }}%</label>
                </ng-container>
                <!--Discount Day Retail-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
                  <label class="font-size-14 fw-bold mb-0">{{ 'member.card.discount.day.retail.value' | translate }}%</label>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-container *inPopulation="[populations.Suite, populations.Pts]">
      <ng-container
        *ngIf="!(isFreePopulation || isPartnerPopulation) || ((isFreePopulation || isPartnerPopulation) && !isHomePage)"
      >
        <div
          class="qr text-center rounded position-relative show-normal-qr"
          [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'"
        >
          <div class="qr-box d-flex flex-column align-items-center justify-content-center">
            <qrcode [qrdata]="barcode.Barcode" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
            <label for="" class="font-size-12 fw-normal text-center text-capitalize text-white">{{
              'barcode.member.scan.qr' | translate
            }}</label>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <div *ngIf="memberCard$ | async as memberCard">
      <ng-container *ngIf="memberCard.RetailDiscountLevel != null || memberCard.RetailDiscountLevel != undefined">
        <div class="member-details d-flex align-items-center">
          <ng-container *inPopulation="[populations.Default, populations.Free, populations.Partner]">
            <div class="card-id" [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'">
              <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
              <div class="card-id-content">
                <label class="text-heading mb-0 text-white">{{ pointsBalance$ | async | number: '1.0-0' }}</label>
                <div class="font-size-12 text-white">{{ 'member.card.points.balance' | translate }}</div>
              </div>
            </div>

            <div class="card-id" [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'">
              <span class="icons material-symbols-outlined text-white money-bag-icon"> money_bag </span>
              <div class="card-id-content">
                <label class="text-heading mb-0 text-white">{{ combinedCard$ | async | FortressCurrencyPipe }}</label>
                <div class="font-size-12 text-white">{{ 'member.card.ecash.balance' | translate }}</div>
              </div>
            </div>
          </ng-container>
          <ng-container *inPopulation="[populations.Suite, populations.Pts]">
            <div class="card-id bg-glass">
              <span class="material-icons"> fastfood </span>
              <div class="card-id-content">
                <!--Discount-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'"
                  ><label class="text-heading mb-0 text-white">{{ memberCard.DiscountLevel | getNumber }}%</label>
                </ng-container>
                <!--Discount Day F&B-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
                  <label class="text-heading mb-0 text-white">{{ 'member.card.discount.day.fandb.value' | translate }}%</label>
                </ng-container>

                <div class="font-size-12 text-white">{{ 'barcode.discountlevel' | translate }}</div>
              </div>
            </div>

            <div class="card-id bg-glass">
              <span class="material-icons"> local_mall </span>
              <div class="card-id-content">
                <!--Retail Discount-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.default.discount'"
                  ><label class="text-heading mb-0 text-white"
                    >{{ memberCard.RetailDiscountLevel | getNumber }}%</label
                  ></ng-container
                >
                <!--Discount Day Retail-->
                <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.discount.day'">
                  <label class="text-heading mb-0 text-white">{{ 'member.card.discount.day.retail.value' | translate }}%</label>
                </ng-container>

                <div class="font-size-12 text-white">{{ 'member.card.discount' | translate }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <ng-container *inPopulation="[populations.Default, populations.Free, populations.Partner]">
      <p class="program-expire-container font-size-10 text-white text-center w-100 mb-0">
        {{ 'member.card.program.expire' | translate }}
      </p>
    </ng-container>

    <!-- mobile navigation -->
    <ng-container *notInPopulation="[populations.Suite, populations.Pts]">
      <ng-container *ngIf="isHomePage">
        <div
          #nav
          class="mobile-navigation d-flex flex-row pb-1"
          [ngClass]="{ 'mobile-navigation-allstar': isFreePopulation }"
          [class.at-end]="atRightEnd"
          (scroll)="onNavScroll()"
        >
          <div class="navigation" routerLink="/rewards/wallet">
            <span [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'" class="icons material-symbols-outlined">
              wallet
            </span>
            <a class="text-white font-size-14">{{ 'member.card.wallet' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/rewards">
            <span [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'" class="icons material-icons">store</span>
            <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/partners">
            <span [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'" class="icons material-icons">group</span>
            <a class="text-white font-size-14">{{ 'member.card.partners' | translate }}</a>
          </div>

          <ng-container *notInPopulation="[populations.Free]">
            <div class="navigation" routerLink="/ecash-transfer">
              <span [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'" class="icons material-icons">paid</span>
              <a class="text-white font-size-14">{{ 'member.card.transfer' | translate }}</a>
            </div>
          </ng-container>

          <div class="navigation" routerLink="/earn">
            <span [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'" class="icons material-symbols-outlined money-icon">
              money
            </span>
            <a class="text-white font-size-14">{{ 'member.card.earn' | translate }}</a>
          </div>

          <ng-container *notInPopulation="populations.Partner">
            <div class="navigation" routerLink="/referAFriend">
              <span [ngClass]="isFreePopulation ? 'bg-glass-dark' : 'bg-glass'" class="icons material-icons"
                >person_add_alt_1</span
              >
              <a class="text-white font-size-14">{{ 'member.card.refer.a.friend' | translate }}</a>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<!-- <ng-container *inPopulation="[populations.Free, populations.Default]">
  <div class="font-size-10 text-center my-2">
    {{ 'barcode.currency.disclaimer' | translate }}
  </div>
</ng-container> -->
